import Tool, {
  type IToolActionInput,
  type IToolAvailableInput,
  type IToolEnabledInput,
  simpleToolButton,
} from './Tool';
import { hasStyleCopyPasteBehaviors } from '../objects/guards';
import Shortcut from '../utils/Shortcut';

class ToolPasteStyle extends Tool {
  static toolName = 'Paste style';

  static shortcut = new Shortcut('Cmd+Option+V');

  static action({ controller }: IToolActionInput) {
    controller.actionPasteStyle();
    this.toolActionComplete({ controller });
  }

  static available({ selection }: IToolAvailableInput) {
    // At least one selected object can accept the paste
    return !!selection
      ?.getObjects()
      .filter(hasStyleCopyPasteBehaviors)
      .some(o => o.canPasteStyles());
  }

  static enabled({ controller, selection }: IToolEnabledInput) {
    const { styleClipboardContents } = controller.state;
    return !!(
      styleClipboardContents &&
      Object.keys(styleClipboardContents).length &&
      super.enabled({ selection, controller })
    );
  }

  static buttonComponent() {
    return simpleToolButton(ToolPasteStyle, 'fa-regular fa-pallete', {
      stopPropagation: true,
    });
  }
}

export default ToolPasteStyle;
